import {Pipe, PipeTransform} from '@angular/core';
import {FilterByPipe} from "ngx-pipes";
import {extractDeepPropertyByMapKey, extractDeepPropertyByParentMapKey, isNull, isUndefined} from "../helpers/general-helpers";

@Pipe({
  name: 'where',
  standalone: true
})
export class WherePipe implements PipeTransform {
  constructor() {
  }

  transform<T>(inputs: T[], prop: string, search?: any, strict?: boolean, negation?: boolean): T[] {

    if (Array.isArray(search)) {
      const r: T[] = [];
      for (const search1 of search as Array<T>) {
        let filterBy1: any = this.filterBy(inputs, [prop], search1, strict, negation);

        if(Array.isArray(filterBy1) && filterBy1?.length > 0){
          r.push(...filterBy1);
        }
      }
      return r;
    } else {
      return this.filterBy(inputs, [prop], search, strict, negation);
    }
  }

  filterBy(input: any, props: Array<string>, search: any = undefined, strict: boolean = false, negation: boolean = false) {
    if (!Array.isArray(input)
    ) {
      return input;
    }

    let terms = String(search)
      .toLowerCase()
      .split(',');

    if (isUndefined(search) || isNull(search)) {
      terms = ['null', 'undefined'];
    }

    return input.filter(obj => {
        if (negation) {
          return props.every(prop => {
            return terms.every(term => {
              return this.filter(obj, prop, term, strict, negation)
            });

          });
        } else {
          return props.some(prop => {
            return terms.some(term => {
              return this.filter(obj, prop, term, strict, negation)
            });
          });
        }
      }
    );
  }

  private filter(obj: any, prop: string, term: string, strict: boolean, negation: boolean) {
    const value = extractDeepPropertyByMapKey(obj, prop);
    /* tslint:disable */
    const {props, tail} = extractDeepPropertyByParentMapKey(obj, prop);

    if (isUndefined(value) && !isUndefined(props) && Array.isArray(props)) {
      return props.some(parent => {
        const str = String(parent[tail]).toLowerCase();

        let b = strict ? str === term : !!~str.indexOf(term);
        return negation ? !b : b;
      });
    }

    const strValue: string = String(value).toLowerCase();

    let b1 = strict ? term === strValue : !!~strValue.indexOf(term);
    return negation ? !b1 : b1;
  }
}
